<template>
    <v-main>
        <ScanTicketComponent v-if="step === 1" />
        <DetailTicketComponent v-else :dataSource="dataDetail" :ticketId="ticketId" :ticketType="ticketType" :detailByScanner="detailByScanner" />
        <ReprintStatusDialog v-if="useNewReprint" />
        <ReprintDialog v-else />
    </v-main>
</template>
<script>
import EventBus from '@/utils/EventBus'

import ScanTicketComponent from '@/components/ScanTicket/index.vue'
import DetailTicketComponent from '@/components/ScanTicket/detail.vue'
import ReprintDialog from '@/components/common/dialog/reprint.vue'
import ReprintStatusDialog from '@/components/common/dialog/reprint-status.vue'
import { isNewReprintCashier } from '@/utils/reprint-mode'

export default {
    components: { DetailTicketComponent, ScanTicketComponent, ReprintDialog, ReprintStatusDialog },
    data() {
        return {
            step: 1,
            dataDetail: null,
            ticketId: '',
            ticketType: '',
            detailByScanner: false,
        }
    },
    computed: {
        useNewReprint() {
            return isNewReprintCashier()
        },
    },
    created() {
        EventBus.$on('on-show-ticket-detail', (payload) => this.onShowTicketDetail(payload))
    },
    destroyed() {
        EventBus.$off('on-show-ticket-detail')
    },
    methods: {
        onShowTicketDetail(payload) {
            this.dataDetail = payload.data
            this.ticketId = payload.ticketId
            this.ticketType = payload.ticketType
            this.detailByScanner = payload.detailByScanner
            this.step = 2
        },
    },
}
</script>
